<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardHeader>
          <strong>Χρήστης:</strong> {{ title }}
        </CCardHeader>
        <CCardBody>
          <CDataTable 
            striped 
            small 
            fixed
            :items="items" 
            :fields="fields"
          >
            <template slot="value" slot-scope="data">
              <td><strong>{{data.item.value}}</strong></td>
            </template>
          </CDataTable>
        </CCardBody>
        <CCardFooter>
          <CButton color="primary" @click="goBack">Πίσω</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'User',
  data: () => {
    return {
      items: [],
      title: '',
      fields: [
        {key: 'key', label: 'Πεδίο'},
        {key: 'value', label: 'Τιμή'},
      ],
    }
  },
  methods: {
    getUserData (id) {
      const user = usersData.find((user, index) => index + 1 == id)
      const userDetails = user ? Object.entries(user) : [['id', 'Not found']]
      return userDetails.map(([key, value]) => { return { key, value } })
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  mounted: function(){
    let self = this;
    axios.get('/api/users/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      //const items = response.data.users;
      const ser_items = Object.entries(response.data).map(([key, value]) => {return {key: key, value: value}});
      const keys = ["name", "email"];
      self.items = ser_items.filter((t) => keys.includes(t.key));
      self.title = self.items.find((t) => t.key == "name").value;

      const items = Object.entries(response.data);
      self.items = items.map(([key, value]) => {return {key: key, value: value}});

      self.items = self.items.map((item) => {
         if (item.key == "id") {
            item.key = "ID:";
        } else if (item.key == "name") {
            item.key = "Ονοματεπώνυμο:";
        } else if (item.key == "email") {
            item.key = "Email:";
        } else if (item.key == "address") {
            item.key = "Διεύθυνση:";
        } else if (item.key == "roles") {
            item.key = "Ρόλος:";
        } else if (item.key == "status") {
            item.key = "Κατάσταση:";
        } else if (item.key == "registered") {
            item.value = moment(new Date(item.value)).format('DD-MM-YYYY HH:mm:ss');
            item.key = "Εγγράφηκε:";
        }  

        return item;
      });
    }).catch(function (error) {
      console.log(error);
      self.$router.push({ path: '/login' });
    });
  }
}

</script>
